import React from 'react';
import { withStyles } from '@material-ui/styles';
import {
    Grid,
    Typography,
    TextField,
    Divider,
    ListItemText,
    TableBody,
    TableRow,
    Table,
    TableCell,
    TableContainer,
    FormControlLabel,
    Checkbox,
    IconButton,
    FormGroup,
    FormLabel,
    FormControl
} from '@material-ui/core';

import { Pagination } from './components';

import FlashOnOutlinedIcon from '@material-ui/icons/FlashOnOutlined';
import InvertColorsIcon from '@material-ui/icons/InvertColors';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';

import ClearIcon from '@material-ui/icons/Clear';

const styles = theme => ({
    searchInput: {
        //paddingRight: theme.spacing(2),
        //paddingLeft: theme.spacing(2)
    },
    container: {
        //maxHeight: "calc(100vh - 456px)"
    },
    containerList: {
        //position: "absolute",
        //width: "100%"
    },
    pageButton: {
        position: 'absolute',
        bottom: 0,
        width: '100%'
    },
    content: {
        //position: "absolute",
        //height: "calc(100vh - 427px)"
    },
    filter: {
        //paddingLeft: theme.spacing(2)
    },
    cellRs: {
        //maxWidth: 185
    },
    labelFilter: {
        color: '#3f51b5',
        marginBottom: 5
    }
});

const StyledTableRow = withStyles(theme => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: 'rgba(0, 0, 0, 0.02)'
        }
    }
}))(TableRow);

const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: '#e1f0fb',
        color: '#3f51b5'
    }
}))(TableCell);

class ListHolders extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props,
            searchValue: '',
            list: [],
            selectedActivities: [],
            numberOfPages: 0,
            page: 1,
            isSubscriber: false,
            isNotSubscriber: false,
            filterHasChanged: false
        };
    }

    componentDidUpdate = (prevProps, prevState) => {
        (prevState.searchValue != this.state.searchValue ||
            (this.state.filterHasChanged &&
                prevState.filterHasChanged != this.state.filterHasChanged) ||
            prevState.isSubscriber != this.state.isSubscriber ||
            prevState.isNotSubscriber != this.state.isNotSubscriber ||
            prevState.page != this.state.page) &&
            this.getData();

        if (!this.props.raz && prevProps.raz != this.props.raz) {
            this.getData();
        }
    };

    componentDidMount = () => {
        this.getData();
    };

    getData = () => {
        const { merchants } = this.props;

        const { searchValue, page, isSubscriber, isNotSubscriber, selectedActivities } = this.state;

        const formData = new FormData();
        formData.append('search', searchValue);
        formData.append('merchants', JSON.stringify(merchants));
        formData.append('page', page);
        formData.append('isNotSubscriber', isNotSubscriber);
        formData.append('isSubscriber', isSubscriber);
        formData.append('from', 'table');
        selectedActivities.length > 0 &&
            formData.append('activities', JSON.stringify(selectedActivities));

        fetch(
            `https://www.${
                window.location.hostname.split('.')[1]
                    ? window.location.hostname.split('.')[0] === 'www'
                        ? window.location.hostname.split('.')[1]
                        : window.location.hostname.split('.')[0]
                    : 'dev'
            }.api.digitmarche.fr/api/market/get-holders-by-for-creation`,
            {
                method: 'POST',
                body: formData
            }
        )
            .then(response => {
                return response.ok ? response.json() : false;
            })
            .then(data => {
                this.setState({
                    ...data,
                    filterHasChanged: false
                });
            })
            .catch(
                error => {
                    console.error(error);
                    this.setState({
                        filterHasChanged: false
                    });
                    alert('Echec de la récupération des données');
                } // Handle the error response object
            );
    };

    handleSearch = ({ target: { value } }) => {
        this.setState({
            searchValue: value
        });
    };

    handleActivitieFilter = id => {
        const { selectedActivities } = this.state;

        const index = selectedActivities.indexOf(id);

        if (index > -1) {
            selectedActivities.splice(index, 1);
        } else {
            selectedActivities.push(id);
        }

        this.setState({
            selectedActivities: selectedActivities,
            filterHasChanged: true
        });
    };

    handleStateOfMerchant = ({ target: { name, checked } }) => {
        this.setState({
            [name]: checked
        });
    };

    handlePagination = page => {
        this.setState({
            page: page
        });
    };

    render() {
        const {
            classes,
            searchValue,
            list,
            selectedActivities,
            isSubscriber,
            isNotSubscriber,
            numberOfPages,
            page
        } = this.state;

        const { activities, merchants } = this.props;

        return (
            <Grid container direction="column" spacing={2}>
                <Grid item>
                    <div className={classes.searchInput}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            onChange={this.handleSearch}
                            value={searchValue}
                            label="Rechercher un commerçant"
                            InputProps={{
                                endAdornment: (
                                    <IconButton
                                        onClick={() =>
                                            this.handleSearch({ target: { value: '' } })
                                        }>
                                        <ClearIcon style={{ color: 'red' }} />
                                    </IconButton>
                                )
                            }}
                        />
                    </div>
                </Grid>
                <Grid item>
                    <div className={classes.filter}>
                        <Grid container direction="column" justify="flex-start" spacing={2}>
                            <Grid item>
                                <FormControl component="fieldset">
                                    <FormLabel className={classes.labelFilter} component="label">
                                        Activité du commerçant
                                    </FormLabel>
                                    <FormGroup row>
                                        {activities.map(({ id, label, color }) => {
                                            return (
                                                <FormControlLabel
                                                    key={label}
                                                    control={
                                                        <Checkbox
                                                            style={{ color: color }}
                                                            checked={Boolean(
                                                                selectedActivities.indexOf(id) > -1
                                                            )}
                                                            onChange={() =>
                                                                this.handleActivitieFilter(id)
                                                            }
                                                        />
                                                    }
                                                    label={<Typography>{label}</Typography>}
                                                />
                                            );
                                        })}
                                    </FormGroup>
                                </FormControl>
                            </Grid>
                            <Grid item>
                                <FormControl component="fieldset">
                                    <FormLabel className={classes.labelFilter} component="label">
                                        Statut du commerçant
                                    </FormLabel>
                                    <FormGroup row>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={isSubscriber}
                                                    onChange={this.handleStateOfMerchant}
                                                    name="isSubscriber"
                                                />
                                            }
                                            label={<Typography>Abonné</Typography>}
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={isNotSubscriber}
                                                    onChange={this.handleStateOfMerchant}
                                                    name="isNotSubscriber"
                                                />
                                            }
                                            label={<Typography>Non abonné</Typography>}
                                        />
                                    </FormGroup>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
                <Grid item>
                    <Divider />
                </Grid>
                <Grid item>
                    <Grid
                        container
                        direction="column"
                        justify="space-between"
                        className={classes.content}>
                        <Grid item className={classes.containerList}>
                            <TableContainer className={classes.container}>
                                <Table size="small">
                                    <TableBody>
                                        {list.length > 0 ? (
                                            list.map(merchant => {
                                                return (
                                                    <StyledTableRow hover key={merchant.order}>
                                                        <StyledTableCell
                                                            align="left"
                                                            key={
                                                                merchant.order +
                                                                merchant.data.place.numero
                                                            }>
                                                            <ListItemText
                                                                primary={`N°${merchant.data.place.numero}`}
                                                                secondary={
                                                                    <Typography variant="body2">
                                                                        {merchant.data.place.meters}{' '}
                                                                        m
                                                                    </Typography>
                                                                }
                                                            />
                                                        </StyledTableCell>
                                                        <StyledTableCell
                                                            align="left"
                                                            key={
                                                                merchant.order +
                                                                merchant.data.raisonSociale
                                                            }>
                                                            <ListItemText
                                                                primary={
                                                                    <Typography noWrap>
                                                                        {
                                                                            merchant.data
                                                                                .raisonSociale
                                                                        }
                                                                    </Typography>
                                                                }
                                                                secondary={
                                                                    <Typography
                                                                        variant="body2"
                                                                        noWrap>
                                                                        {merchant.data.metierLabel}
                                                                    </Typography>
                                                                }
                                                            />
                                                        </StyledTableCell>
                                                        <StyledTableCell
                                                            align="left"
                                                            key={merchant.order + 'options'}>
                                                            {merchant.data.place.water && (
                                                                <Grid item>
                                                                    <Grid
                                                                        container
                                                                        alignItems="center"
                                                                        spacing={1}>
                                                                        <Grid item>Eau</Grid>
                                                                        <Grid item>
                                                                            <InvertColorsIcon
                                                                                style={{
                                                                                    color:
                                                                                        'dodgerblue'
                                                                                }}
                                                                            />
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            )}
                                                            {merchant.data.place.electricity && (
                                                                <Grid item>
                                                                    <Grid
                                                                        container
                                                                        alignItems="center"
                                                                        spacing={1}>
                                                                        <Grid item>
                                                                            Electricité
                                                                        </Grid>
                                                                        <Grid item>
                                                                            <FlashOnOutlinedIcon
                                                                                style={{
                                                                                    color: 'gold'
                                                                                }}
                                                                            />
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            )}
                                                            {merchant.data.place.car && (
                                                                <Grid item>
                                                                    <Grid
                                                                        container
                                                                        alignItems="center"
                                                                        spacing={1}>
                                                                        <Grid item>Véhicule</Grid>
                                                                        <Grid item>
                                                                            <LocalShippingIcon />
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            )}
                                                            {!merchant.data.place.car &&
                                                                !merchant.data.place.water &&
                                                                !merchant.data.place
                                                                    .electricity && (
                                                                    <Grid item>
                                                                        <Typography>
                                                                            Sans option
                                                                        </Typography>
                                                                    </Grid>
                                                                )}
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                );
                                            })
                                        ) : (
                                            <TableRow>
                                                <TableCell
                                                    align="center"
                                                    style={{ border: 'none' }}>
                                                    <Typography align="center">
                                                        Aucun commerçant n'a été trouvé...
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                        <Grid item>
                            <Pagination
                                numberOfPages={numberOfPages}
                                currentPage={page}
                                handlePagination={this.handlePagination}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(styles)(ListHolders);
